<template>
  <div :class="{ 'has-error': showError, 'form-group': !stacked }">
    <div :class="{ 'col-lg-4': !stacked }" v-if="label">
      <label class="control-label"
        >{{ label }}: <span v-if="required">*</span></label
      >
      <p class="help-block" v-text="helper" v-if="helper"></p>
    </div>
    <div
      :class="{
        'col-lg-6': $slots.rightBtn,
        'col-lg-8': !stacked && label && !$slots.rightBtn,
        'w-100': !stacked && !label && !$slots.rightBtn
      }"
    >
      <select
        :name="name"
        class="form-control"
        v-model="innerValue"
        :disabled="readonly"
      >
        <option value="">{{ placeholder || 'Please Select' }}</option>
        <option
          :key="i"
          :value="option[keyName]"
          v-for="(option, i) in options"
        >
          {{ getOptionLabel(option) }}
        </option>
      </select>
      <p class="text-danger" v-if="showError" v-text="errorMessage"></p>
    </div>
    <div class="col-lg-2" v-if="$slots.rightBtn">
      <slot name="rightBtn"></slot>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    keyName: {
      type: String,
      default: () => {
        return 'id';
      }
    },
    labelName: {
      type: String,
      default: () => {
        return 'label';
      }
    },
    helper: String,
    showError: Boolean,
    placeholder: String,
    stacked: Boolean,
    value: [String, Number],
    required: Boolean,
    errorMessage: String,
    logging: {
      Type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    innerValue: {
      get() {
        return this.value || '';
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },

  methods: {
    setValue(value) {
      this.$emit('input', value);
    },

    getOptionLabel(option) {
      if (this.labelName.includes('.')) {
        const parts = this.labelName.split('.');

        return parts.reduce((option, value) => {
          if (option) {
            return option[value];
          }

          return null;
        }, option);
      }

      return option[this.labelName];
    }
  }
};
</script>
